import { Contacts } from './contacts';
import { Conversations } from './conversations';
import { ContactNumber } from './contact-number';


export class Data {

    public id: number;

    public title: string;
    public description: string;
    public date: string;

    public isHighlighted: boolean;

    public contact: Contacts;
    public contact_number: ContactNumber;
    public conversation: Conversations;
}
